import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const portal = searchParams.get("portal");
  const backTo = portal ? `/${portal}` : "/login";
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch { /* réponse générique, on n'expose rien */ }
    finally { setLoading(false); setSent(true); }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="rounded-sm border border-border bg-card p-8 sm:p-10">
          <div className="font-heading text-xl font-semibold">Suivio<span className="text-primary">360</span></div>
          {sent ? (
            <div className="mt-8 text-center" data-testid="forgot-sent">
              <MailCheck className="mx-auto h-10 w-10 text-green-600" />
              <h1 className="mt-6 text-2xl font-semibold">Vérifiez votre email</h1>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                Si cette adresse correspond à un compte, un email contenant un lien sécurisé de réinitialisation vient d'être envoyé. Le lien est valable 1 heure.
              </p>
            </div>
          ) : (
            <>
              <h1 className="mt-8 text-2xl font-semibold tracking-tight">Mot de passe oublié</h1>
              <p className="mt-2 text-sm text-muted-foreground">
                Saisissez l'adresse email de votre compte. Nous vous enverrons un lien pour définir un nouveau mot de passe.
              </p>
              <form onSubmit={submit} className="mt-8 space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="fp-email">Adresse email</Label>
                  <Input id="fp-email" data-testid="forgot-email-input" type="email" required value={email}
                    onChange={(e) => setEmail(e.target.value)} className="rounded-sm" placeholder="vous@exemple.com" />
                </div>
                <Button data-testid="forgot-submit-button" type="submit" disabled={loading}
                  className="w-full rounded-sm bg-primary text-white hover:bg-red-700 transition-colors duration-200">
                  {loading ? "Envoi…" : "Envoyer le lien de réinitialisation"}
                </Button>
              </form>
            </>
          )}
        </div>
        <p className="mt-6 text-center text-xs text-muted-foreground">
          <Link to={backTo} data-testid="forgot-back-to-login" className="inline-flex items-center gap-1 text-primary hover:underline">
            <ArrowLeft className="h-3 w-3" /> Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
